import { appWithTranslation } from 'next-i18next'
import { AppProps } from 'next/app'
import getConfig from 'next/config'
import Head from 'next/head'
import React from 'react'
import { createGlobalStyle } from 'styled-components'

import { resetStyleCss } from '@web-apps/ui-shared'
import { initAPI, initConfig } from '@web-apps/utils-shared'
import {
  CreatorPageTheme,
  CustomizationFormProperties,
  FontEnum,
} from '@web-apps/utils-types'
import 'react-loading-skeleton/dist/skeleton.css'
import { MetaHead } from '../src/components/MetaHead/MetaHead.component'
import { wrapper } from '../src/services/store'
import '../src/styles/index.css'

const { i18n } = require('../next-i18next.config')

const GlobalStyle = createGlobalStyle`${resetStyleCss}`
const FontStyles = createGlobalStyle`
  body {
    font-family: ${({ theme }: { theme: CreatorPageTheme }) =>
      `${
        theme?.customization?.[CustomizationFormProperties.FONT] ||
        FontEnum.INTER
      }, sans-serif`};

    ${({ theme }) => {
      return theme?.customization?.[CustomizationFormProperties.FONT] ===
        FontEnum.AMATIC_SC
        ? 'font-size: 16px;'
        : ''
    }}
  }
`

const App: React.ComponentType<AppProps> = ({ Component, pageProps }) => {
  const { publicRuntimeConfig } = getConfig()

  initConfig({
    IFRAMELY_KEY: publicRuntimeConfig.iframely.key,
    CHARGEBEE_SITE: publicRuntimeConfig.chargebee.site,
    CREATOR_APP_BASE_URL: publicRuntimeConfig.baseUrls.creatorApp,
    CREATOR_APP_V2_BASE_URL: publicRuntimeConfig.baseUrls.creatorAppV2,
    PUBLIC_APP_BASE_URL: publicRuntimeConfig.baseUrls.publicApp,
    AUTH_URL: '',
  })
  initAPI({
    baseURL: publicRuntimeConfig.baseUrls.backend,
  })

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="viewport-fit=cover, width=device-width, initial-scale=1"
        />
      </Head>
      <MetaHead />
      <GlobalStyle />
      <FontStyles />
      <Component {...pageProps} />
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default wrapper.withRedux(appWithTranslation(App, { i18n }))
